import React, { useEffect, useState } from 'react'
import { Button, Card } from '@material-ui/core'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import {
  getMaterialsGroups,
  getUserGroupsProfile,
  getUserMaterialsGroup,
  getUserProfiles,
  postFiltrarTabla,
  postGroupMaterialState,
  postGraficaEventos,
} from '@auteco/services/snopServices'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { Alert } from '../Alert'
import { ReturnButton } from '../ReturnButton'
import { DetailsPage } from '../DetailsPage'
import { AutocompleteToSearch } from './components/AutocompleteToSearch'
import useStyles from './styles'
import PageFilters from './pages/PageFilters'
import { FinalValuesTable } from './components/FinalValuesTable'
import { EventosTable } from './components/EventosTable/EventosTable'

const ManagerSection = ({ handleReturnHome }) => {
  const [savedMaterialsFiltered, setSavedMaterialsFiltered] = useState([])
  const [managerVisible, setManagerVisible] = useState(true)
  const [detailsVisible, setDetailsVisible] = useState(false)
  const [groups, setGroups] = useState([])
  const [profiles, setProfiles] = useState([])
  const [groupsProfile, setGroupsProfile] = useState([])
  const [groupId, setGroupId] = useState('')
  const [page, setPage] = useState('filtros')
  const [materials, setMaterials] = useState([])
  const [currentMaterial, setCurrentMaterial] = useState('')
  const [loading, setLoading] = useState(false)
  const [materialChanged, setMaterialChanged] = useState(0)

  const [filters, setFilters] = useState([])
  const [filtersSaved, setFiltersSaved] = useState([])
  const [tableData, setTableData] = useState([])
  const [tableEventsData, setTableEventsData] = useState([])
  const [selectedGroup, setSelectedGroup] = useState('')
  const [alertInfo, setAlertInfo] = useState('initialAlert')

  const handleCloseMaterialByGroup = async () => {
    await postGroupMaterialState({ grupo_id: selectedGroup, estado: 1 })
    await getTableData()
    onCloseAlert()
  }

  const initialAlert = {
    title: '',
    content: '',
    textBtn1: '',
    textBtn2: '',
    funcBtn: () => {},
    open: false,
    onClose: () => {},
  }

  const onCloseAlert = () => {
    setAlertInfo(initialAlert)
  }

  const closeMaterial = async () => {
    setAlertInfo({
      title: '¡Espera!',
      content:
        'Estás a punto de finalizar todos los materiales de este grupo, ¿deseas continuar?',
      textBtn1: 'Cancelar',
      textBtn2: 'Continuar',
      open: true,
      onClose: onCloseAlert,
      funcBtn: handleCloseMaterialByGroup,
    })
  }

  const classes = useStyles()

  const handleSaveMaterialsFiltered = (materialsFiltered) => {
    setSavedMaterialsFiltered(materialsFiltered)
  }

  const getTableData = async () => {
    if (filtersSaved) {
      const datafiltered = await postFiltrarTabla({ params: filtersSaved })
      setTableData(datafiltered)
    }
  }

  const getEvents = async () => {
    if (filtersSaved) {
      const eventsFiltered = await postGraficaEventos({ params: filtersSaved })
      setTableEventsData(eventsFiltered.eventos)
      console.log(eventsFiltered.eventos)
    }
  }

  const getGroups = async () => {
    setLoading(true)
    const { grupos } = await getMaterialsGroups()

    if (grupos) {
      setGroups(grupos)
    }
    setLoading(false)
  }

  const getProfiles = async () => {
    setLoading(true)
    const { perfiles } = await getUserProfiles()
    if (perfiles) {
      setProfiles(perfiles)
    }
    setLoading(false)
  }

  const searchByGroup = async ({ id }) => {
    setLoading(true)
    setGroupId(id)
    if (id !== '') {
      const { materiales } = await getUserMaterialsGroup({ id })
      if (materiales) {
        setMaterials(materiales)
      }
    } else {
      setMaterials([])
    }
    setLoading(false)
  }

  const searchByProfile = async ({ id }) => {
    setLoading(true)
    if (id !== '') {
      const { grupos } = await getUserGroupsProfile({ id })
      if (grupos) {
        setGroupsProfile(grupos)
      }
    } else {
      setMaterials([])
      setGroupsProfile([])
    }
    setLoading(false)
  }

  const getUpdatedMaterials = async () => {
    setLoading(true)
    if (page === 'filtros') {
      // searchByFilters()
    } else {
      const { materiales } = await getUserMaterialsGroup({ id: groupId })
      if (materiales) {
        setMaterials(materiales)
      }
    }
    setLoading(false)
  }

  const handleMaterialChanged = () => {
    setMaterialChanged(materialChanged + 1)
  }

  const handleViewDetails = ({ material }) => {
    setCurrentMaterial(material)
    setManagerVisible(false)
    setDetailsVisible(true)
  }

  const handleReturnMainPage = () => {
    setManagerVisible(true)
    setDetailsVisible(false)
  }

  const changeSearchPage = ({ value }) => {
    setMaterials([])
    setGroupsProfile([])
    setPage(value)
  }

  useEffect(() => {
    getGroups()
    getProfiles()
  }, [])

  useEffect(() => {
    getTableData()
    getEvents()
  }, [filtersSaved])

  const handleSelectChange = (event) => {
    setSelectedGroup(event.target.value)
  }

  return (
    <>
      <div style={{ display: managerVisible ? 'block' : 'none' }}>
        <ReturnButton onClick={handleReturnHome} />
        <Card className={classes.mainContainer}>
          <CardTitle title={`Buscar materiales por ${page}`} />
          <div className={classes.mainContainerBtns}>
            <div className={classes.containerBtns}>
              <Button
                className={
                  page === 'filtros' ? classes.selectedBtn : classes.btn
                }
                variant="contained"
                onClick={() => changeSearchPage({ value: 'filtros' })}
              >
                Filtros
              </Button>
            </div>
          </div>
          <Card className={classes.filtersContainer}>
            {page === 'filtros' && (
              <>
                <Alert
                  title={alertInfo.title}
                  content={alertInfo.content}
                  textBtn1={alertInfo.textBtn1}
                  textBtn2={alertInfo.textBtn2}
                  funcBtn={alertInfo.funcBtn}
                  open={alertInfo.open}
                  onClose={onCloseAlert}
                />

                <PageFilters
                  materials={materials}
                  setMaterials={setMaterials}
                  handleViewDetails={handleViewDetails}
                  getUpdatedMaterials={getUpdatedMaterials}
                  savedMaterialsFiltered={savedMaterialsFiltered}
                  onSaveMaterialsFiltered={handleSaveMaterialsFiltered}
                  loading={loading}
                  setLoading={setLoading}
                  materialChanged={materialChanged}
                  filters={filters}
                  setFilters={setFilters}
                  filterssaved={filtersSaved}
                  setFiltersSaved={setFiltersSaved}
                >
                  <>
                    <br />
                    {tableData && tableData.length > 0 && (
                      <>
                        <br /> <h4>Resumen</h4> <br />
                        
                        <FinalValuesTable consolidadoMaterialInfo={tableData} />
                        <br /> <h4>Eventos</h4> <br />
                        {tableEventsData && tableEventsData.length > 0 && (
                          <EventosTable eventos={tableEventsData} />
                        )}
                      </>
                    )}
                    <br />
                    {/* nueva */}
                    <br />
                    <Card className={classes.mainContainer}>
                      <h3>Finalizar por grupo </h3>

                      <FormControl fullWidth>
                        <InputLabel id="groupSelectLabel">
                          Seleccionar un grupo
                        </InputLabel>
                        <Select
                          labelId="groupSelectLabel"
                          id="groupSelect"
                          value={selectedGroup}
                          onChange={handleSelectChange}
                        >
                          <MenuItem value="">
                            <em>Seleccione un grupo</em>
                          </MenuItem>
                          {groups.map((group) => (
                            <MenuItem key={group.id} value={group.id}>
                              {group.nombre}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={closeMaterial}
                        disabled={!selectedGroup}
                        style={{ marginTop: '10px' }}
                      >
                        Finalizar
                      </Button>
                    </Card>
                  </>
                </PageFilters>

                <br />
              </>
            )}
            {page === 'perfil' && (
              <>
                <AutocompleteToSearch
                  label="Perfiles"
                  options={profiles}
                  onChange={searchByProfile}
                />
                {groupsProfile.length > 0 && (
                  <AutocompleteToSearch
                    label="Grupos"
                    options={groupsProfile}
                    onChange={searchByGroup}
                  />
                )}
              </>
            )}
            {page === 'grupo' && (
              <AutocompleteToSearch
                label="Grupos"
                options={groups}
                onChange={searchByGroup}
              />
            )}
          </Card>
        </Card>
      </div>
      <div style={{ display: detailsVisible ? 'block' : 'none' }}>
        {currentMaterial && materials && (
          <DetailsPage
            rol={2}
            groupId={groupId}
            materialId={currentMaterial}
            materials={materials}
            handleReturnMainPage={handleReturnMainPage}
            setMaterialChanged={handleMaterialChanged}
            materialChanged={materialChanged}
            setMaterials={setMaterials}
            detailsVisible={detailsVisible}
            setDetailsVisible={setDetailsVisible}
          />
        )}
      </div>
    </>
  )
}

export { ManagerSection }
